import {outter_post,post} from 'common/js/axios-helper';
import {PowerUserApi} from "./constant/UrlMapper";


const host ="8882"


const list = (data) => {
    return post(PowerUserApi.List, data, host, true);
};
const add = (data) => {
    return post(PowerUserApi.Add, data, host, true);
};
const update = (data) => {
    return post(PowerUserApi.Update, data, host, true);
};
const Delete = (data) => {
    return post(PowerUserApi.Delete, data, host, true);
};
const modifypw = (data) => {
    return post(PowerUserApi.ModifyPW, data, host, true);
};
const selectone = (data) => {
    return post(PowerUserApi.SelectOne, data, host, true);
};
const selectperms = (data) => {
    return post(PowerUserApi.selectPerms, data, host, true);
};

export default {list,add,update,Delete,modifypw,selectone,selectperms}



// WEBPACK FOOTER //
// ./src/service/PowerUserService.js